module.exports = __webpack_public_path__ + "static/media/Ellipse.3db607c4.png";